import { useEffect, useState, useMemo, useContext } from "react";
import { auth } from "../../firebase";
import { onAuthStateChanged, User } from "firebase/auth";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import { Box, Switch, useColorModeValue } from "@chakra-ui/react";
import { ContextApp } from "../../shared/ContextApp";
import { AuthenticationService } from "../../services/AuthenticationService";

import {
  BrowserRouter,
  Route,
  Router,
  Outlet,
  useNavigate,
} from "react-router-dom";
import Home from "../Home/Home";

function LayoutAdmin({ children }: any) {
  const { user } = useContext(ContextApp);
  const navigate = useNavigate();
  // const { loading, error, data } = useQuery(PRODUCTS);
  const { logout } = AuthenticationService();

  useEffect(() => {
    if (user) {
      if (user.role === "customer") {
        navigate("/");
      }
    }
  }, [user]);

  return (
    <>
      <div className="container-layout">
        <div className="container-header">
          <Header />
        </div>
        <Box className="container-content">
          <Outlet />
        </Box>
        <div className="container-footer">
          <Footer />
        </div>
      </div>
    </>
  );
}

export default LayoutAdmin;
